import { TFunction } from 'i18next';
import * as yup from 'yup';
import { MAX_FILE_SIZE } from '~/utils/constants/common';
import { IBaseFile } from '~/utils/interface/common';

export const schema = (t: TFunction) =>
  yup.object({
    files: yup
      .array()
      .of(
        yup.object<IBaseFile>().shape({
          file: yup
            .mixed<File>()
            .optional()
            .test('fileSize', t('common_validate_size_file'), (file) => !!file && file.size <= MAX_FILE_SIZE),
        })
      )
      .min(1, t('common_validate_field_required'))
      .required(t('common_validate_field_required')),
  });
